package com.patronat.top.ui.atoms

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.theme.LabelLarge
import com.patronat.top.ui.theme.MineShaft950
import com.patronat.top.ui.theme.Primary300

@Composable
fun AvatarCircle(
    initials: String,
    modifier: Modifier = Modifier,
    size: Dp = 40.dp,
    backgroundColor: Color = Primary300,
    contentColor: Color = MineShaft950,
    borderColor: Color = MineShaft950,
    borderWidth: Dp = 1.dp
) {
    Box(
        modifier = modifier
            .size(size)
            .border(
                width = borderWidth,
                color = borderColor,
                shape = CircleShape
            )
            .clip(CircleShape)
            .background(backgroundColor),
        contentAlignment = Alignment.Center
    ) {
        Text(
            text = initials.uppercase().take(2),
            style = LabelLarge,
            color = contentColor
        )
    }
}